import React from "react";
import { CheckboxOptionType } from "antd/es/checkbox";
import { DropdownInput } from "components";
import styles from "./LearningAssets.module.scss";

interface Props {
  levelOptions: CheckboxOptionType[];
  lessonOptions: CheckboxOptionType[];
  selectedLevels: number[];
  selectedLessons: number[];
  setSelectedLevels: (levels: number[]) => void;
  setSelectedLessons: (lessons: number[]) => void;
  disabled?: boolean;
}

function LessonEntryFilters({
  levelOptions,
  lessonOptions,
  selectedLevels,
  selectedLessons,
  setSelectedLevels,
  setSelectedLessons,
  disabled,
}: Props) {
  return (
    <>
      <div className={styles.filter}>
        <span className={styles.filterLabel}>Level:</span>
        <div className={styles.filterSelect}>
          <DropdownInput
            options={levelOptions}
            value={selectedLevels}
            onChange={setSelectedLevels}
            placeholder="All levels"
            disabled={disabled}
          />
        </div>
      </div>
      <div className={styles.filter}>
        <span className={styles.filterLabel}>Lesson:</span>
        <div className={styles.filterSelect}>
          <DropdownInput
            options={lessonOptions}
            value={selectedLessons}
            onChange={setSelectedLessons}
            placeholder="All lessons"
            disabled={disabled}
          />
        </div>
      </div>
    </>
  );
}

export default LessonEntryFilters;
